import {
  TextField as MaterialTextField,
  OutlinedInputProps,
  TextFieldProps,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core";

const defaultBorder = (theme): string => {
  return theme.palette.border.input;
};

export const useInputStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        overflow: "hidden",
        backgroundColor: theme.palette.common.white,

        "& input": {
          border: `1px solid ${defaultBorder(theme)}`,
          padding: "10px 14px 16px 14px",
          borderRadius: 2,
          flex: 1,
          textAlign: "center",
          transition: theme.transitions.create([
            "border-color",
            "box-shadow",
            "background-color",
          ]),

          "&:hover": {
            backgroundColor: "#fcfcfb",
          },
          "&:focus": {
            backgroundColor: theme.palette.common.white,
          },

          "&::placeholder": {
            fontSize: 15,
          },
          "&::-moz-placeholder": {
            fontSize: 15,
          },
          "&::-ms-input-placeholder": {
            fontSize: 15,
          },
        },
      },
      focused: {},
    }),
  { name: "custom-text-field", flip: null }
);

export const useStyles = makeStyles(
  (theme) =>
    createStyles({
      wrapper: {
        position: "relative",
        width: "100%",
      },
    }),
  { name: "custom-text-field", flip: null }
);

export const BusinessSearchInput = (props: TextFieldProps | any) => {
  const classes = useInputStyles(props);
  const layoutClasses = useStyles(props);

  return (
    <div className={layoutClasses.wrapper}>
      <MaterialTextField
        InputProps={
          { classes, disableUnderline: true } as Partial<OutlinedInputProps>
        }
        {...props}
      />
    </div>
  );
};
